import { Router } from "aurelia-router";
import { find } from "lodash";
import { observable, computedFrom, Disposable, autoinject, child } from "aurelia-framework";
import { EventAggregator } from "aurelia-event-aggregator";
import { ReportWordExportDialog } from "../../features/reporting/report-word-export-dialog";
import { ResourcedNotificationService } from "../notifications/notification-service";
import { ReportService } from "../../features/reporting/report-api";
import { ReportingStateService } from "../../features/reporting/reporting-state-service";

export interface IToolbarLink {
	title: string;
	isBackButton: boolean;
	isWordExportButton: boolean;
	route: IRouteConfig;
}

export interface IRouteConfig {
	name: string;
	url: string;
	params: string[];
}

@autoinject
export class ToolbarLinks {
	@child("report-word-export-dialog") wordExportDialog: ReportWordExportDialog = new ReportWordExportDialog(this.api, this.reportingStateService, this.notificationService);
	@observable customerId: string;
	
	@observable toolbarLinksForRoute: IToolbarLink[];
	routeCompleteSubscriber: Disposable
	containerElement: HTMLElement;

	@computedFrom("toolbarLinksForRoute")
	get backBtnLink(): IToolbarLink {
		return find(this.toolbarLinksForRoute, { isBackButton: true });
	}

	@computedFrom("toolbarLinksForRoute")
	get linksExcludeBackBtn(): IToolbarLink[] {
		return this.toolbarLinksForRoute 
			? this.toolbarLinksForRoute.filter(link => !link.isBackButton)
			: null
	}

	constructor(private router: Router, 
		private ea: EventAggregator, 
		private api: ReportService, 
		private reportingStateService: ReportingStateService,
		private notificationService: ResourcedNotificationService) {
		this.containerElement = document.querySelector("#layout-link-toolbar") as HTMLElement;
	}

	attached() {
		this.routeCompleteSubscriber = this.ea.subscribe("router:navigation:complete", () => {
			if(this.router.currentInstruction) {
				const config = this.router.currentInstruction.config;
				this.toolbarLinksForRoute = config.settings.links;
	
				if(this.toolbarLinksForRoute) {
					this.containerElement.style.display = 'block';
				} else {
					this.containerElement.style.display = 'none';
				}
			}
		});
	}

	navigate(link: IToolbarLink) {
		if (link.isWordExportButton) {
			this.customerId = this.router.currentInstruction.params["customerId"];
			setTimeout(() => {
				this.wordExportDialog.openDialog();
			}, 10)
			
			return;
		}
		
		if(link.route.name) {
			const params = {};
			if(link.route.params) {
				link.route.params.forEach(param => params[param] = this.router.currentInstruction.params[param]);
			}

			this.router.navigateToRoute(link.route.name, params);
		} else {
			let url = link.route.url;
			if(link.route.params) {
				link.route.params.forEach(param => {
					url = url.replace(`{${param}}`, this.router.currentInstruction.params[param]);
				});
			}
			window.location.href = url;
		}
	}

	detached() {
		this.routeCompleteSubscriber.dispose();
	}
}
